import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/academicdashboard'));
// EXAMINATION
const ExaminationListPage = lazy(() => import('src/pages/dashboard/examination-academic/list'));
const ExaminationCreatePage = lazy(() => import('src/pages/dashboard/examination-academic/new'));
const ExaminationEditPage = lazy(() => import('src/pages/dashboard/examination-academic/edit'));
const ExaminationProfilePage = lazy(() => import('src/pages/dashboard/examination-academic/profile'));
// PATTREN
const PattrenListPage = lazy(() => import('src/pages/dashboard/pattren-academic/list'));
const PattrenCreatePage = lazy(() => import('src/pages/dashboard/pattren-academic/new'));
const PattrenEditPage = lazy(() => import('src/pages/dashboard/pattren-academic/edit'));
const PattrenDuplicatePage = lazy(() => import('src/pages/dashboard/pattren-academic/duplicate'));
// OFFLINE-EXAM
const OfflineExamListPage = lazy(() => import('src/pages/dashboard/offline-exam-academic/list'));
const OfflineExamCreatePage = lazy(() => import('src/pages/dashboard/offline-exam-academic/new'));
const OfflineExamEditPage = lazy(() => import('src/pages/dashboard/offline-exam-academic/edit'));
// EXAM LOG
const ExamLogListPage = lazy(() => import('src/pages/dashboard/exam-log-academic/list'));

// ATTENDANCE-ADMIN
const AttendanceAdminPage = lazy(() => import('src/pages/dashboard/attendance-academic/list'));
const AttendanceAdminEditPage = lazy(() => import('src/pages/dashboard/attendance-academic/edit'));
const AttendanceAdminCreatePage = lazy(() => import('src/pages/dashboard/attendance-academic/new'));

// QUESTION BANK
const QuestionBankListPage = lazy(() => import('src/pages/dashboard/questionbank-academic/list'));
const QuestionBankCreatePage = lazy(() => import('src/pages/dashboard/questionbank-academic/new'));
const QuestionBankEditPage = lazy(() => import('src/pages/dashboard/questionbank-academic/edit'));


// TASK
const TaskListPage = lazy(() => import('src/pages/dashboard/task-academic/list'));


// BATCH TOPPER REPORT
const BatchTopperReportPage = lazy(() => import('src/pages/dashboard/reports-academic/batch-topper'));
const TestResultReportPage = lazy(() => import('src/pages/dashboard/reports-academic/test-result-report'));
const QuizSubjectMarksReportPage = lazy(() => import('src/pages/dashboard/reports-academic/quiz-subject-marks-report'));

// QUESTION WISE ANALYSIS REPORT
const QuesWiseAnalysisReportPage = lazy(() => import('src/pages/dashboard/reports-academic/question-wise-analysis-report'));

// STUDENT TEST ANALYSIS REPORT
const StudentTestAnalysisReportPage = lazy(() => import('src/pages/dashboard/reports-academic/student-test-analysis-report'));
// STUDENT QUESTION WISE ANALYSIS REPORT
const StudentQuesWiseAnalysisReportPage = lazy(() => import('src/pages/dashboard/reports-academic/student-question-wise-analysis-report'));
// STUDENT REPORT CARD
const StudentReportCardPage = lazy(() => import('src/pages/dashboard/reports-academic/student-report-card-report'));

// SYLLABUS
const SyllabusCreatePage = lazy(() => import('src/pages/dashboard/syllabus-academic/new'));
const SyllabusListPage = lazy(() => import('src/pages/dashboard/syllabus-academic/list'));
const SyllabusEditPage = lazy(() => import('src/pages/dashboard/syllabus-academic/edit'));
const SyllabusProfilePage = lazy(() => import('src/pages/dashboard/syllabus-academic/profile'));
const SyllabusLog = lazy(() => import('src/pages/dashboard/syllabus-academic/logs'));

// QUESTION BANK
const QuestionBankProfilePage = lazy(() => import('src/pages/dashboard/questionbank-academic/profile'));
const QuestionBankAllocationPage = lazy(() => import('src/pages/dashboard/questionbank-academic/allocation'));
//ASSIGNMENT
const AssignmentListPage = lazy(() => import('src/pages/dashboard/academic-assignment/list'));
const AssignmentAllocatedPage = lazy(() => import('src/pages/dashboard/academic-assignment/allocated-students'));
const AssignmentCompletedPage = lazy(() => import('src/pages/dashboard/academic-assignment/completed-students'));
const TeacherTimeTableViewPage = lazy(() => import('src/pages/dashboard/teacher-timetable/timetableviewpage'));

// ----------------------------------------------------------------------

export const academicdashboardRoutes = [
  {
    path: 'academicdashboard',
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['academic']} hasContent>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      
      {
        path: 'examination',
        children: [
          { element: <ExaminationListPage />, index: true },
          { path: ':id/profile', element: <ExaminationProfilePage /> },
          { path: 'list', element: <ExaminationListPage /> },
          { path: 'log', element: <ExamLogListPage /> },
          { path: 'new', element: <ExaminationCreatePage /> },
          { path: ':id/edit', element: <ExaminationEditPage /> },
        ],
      },

      {
        path: 'pattern',
        children: [
          { element: <PattrenListPage />, index: true },
          { path: 'list', element: <PattrenListPage /> },
          { path: 'new', element: <PattrenCreatePage /> },
          { path: ':id/edit', element: <PattrenEditPage /> },
          { path: ':id/duplicate', element: <PattrenDuplicatePage /> },
        ],
      },

      {
        path: 'attendanceadmin',
        children: [
          { element: <AttendanceAdminPage />, index: true },
          { path: 'list', element: <AttendanceAdminPage /> },
          { path: 'new', element: <AttendanceAdminCreatePage /> },
          { path: ':id/edit', element: <AttendanceAdminEditPage /> },
        ],
      },
      {
        path: 'questionbank',
        children: [
          { element: <QuestionBankListPage />, index: true },
          { path: 'list', element: <QuestionBankListPage /> },
          { path: 'new', element: <QuestionBankCreatePage /> },
          { path: ':id/edit', element: <QuestionBankEditPage /> },
          { path: ':id/profile', element: <QuestionBankProfilePage /> },
          { path: ':id/allocation', element: <QuestionBankAllocationPage /> },
        ],
      },
     {
        path: 'assignment',
        children: [
          { element: <AssignmentListPage />, index: true },
          { path: 'list', element: <AssignmentListPage /> },
          { path: ':id/allocated', element: <AssignmentAllocatedPage /> },
          { path: ':id/completed', element: <AssignmentCompletedPage /> },
          
        ],
      },
       {
        path: 'teachertimetable',
        children: [
          { element: <TeacherTimeTableViewPage />, index: true },
          { path: 'list', element: <TeacherTimeTableViewPage /> },
        
          
        ],
      },
      
      {
        path: 'testresultreport',
        children: [
          { element: <TestResultReportPage/>, index: true },
          { path: 'list', element: <TestResultReportPage /> },
        ],
      },
      {
        path: 'quizsubjectmarksreport',
        children: [
          { element: <QuizSubjectMarksReportPage />, index: true },
          { path: 'list', element: <QuizSubjectMarksReportPage /> },
        ],
      },
      {
        path: 'queswiseanalysis',
        children: [
          { element: <QuesWiseAnalysisReportPage />, index: true },
          { path: 'list', element: <QuesWiseAnalysisReportPage /> },
        ],
      },
      {
        path: 'studenttestanalysis',
        children: [
          { element: <StudentTestAnalysisReportPage />, index: true },
          { path: 'list', element: <StudentTestAnalysisReportPage /> },
        ],
      },
      {
        path: 'studentqueswiseanalysis',
        children: [
          { element: <StudentQuesWiseAnalysisReportPage />, index: true },
          { path: 'list', element: <StudentQuesWiseAnalysisReportPage /> },
        ],
      },
      {
        path: 'studentreportcard',
        children: [
          { element: <StudentReportCardPage />, index: true },
          { path: 'list', element: <StudentReportCardPage /> },
        ],
      },
      {
        path: 'task',
        children: [
          { element: <TaskListPage />, index: true },
          { path: 'list', element: <TaskListPage /> },
        
        ],
      },
 
      
     
      {
        path: 'batchtopper',
        children: [
          { element: <BatchTopperReportPage />, index: true },
          { path: 'list', element: <BatchTopperReportPage /> },
        
        ],
      },
         {
        path: 'syllabus',
        children: [
          { element: <SyllabusListPage />, index: true },
          { path: 'list', element: <SyllabusListPage /> },
          { path: 'new', element: <SyllabusCreatePage /> },
          { path: ':id/edit', element: <SyllabusEditPage /> },
          { path: ':id/profile', element: <SyllabusProfilePage /> },
          { path: 'logs', element: <SyllabusLog /> },
          
        ],
      },
      {
        path: 'offlineexam',
        children: [
          { element: <OfflineExamListPage />, index: true },
          { path: 'list', element: <OfflineExamListPage /> },
          { path: 'new', element: <OfflineExamCreatePage /> },
          { path: ':id/edit', element: <OfflineExamEditPage /> },
        ],
      },
    ],
  },
];